import { Link, Outlet } from 'react-router-dom';
import { Fragment } from 'react';
import { toAbsoluteUrl } from '@/utils';
import useBodyClasses from '@/hooks/useBodyClasses';
import { AuthBrandedLayoutProvider } from './AuthBrandedLayoutProvider';
import { Footer } from '@/layouts/buddy';

const Layout = () => {
  useBodyClasses('dark:bg-coal-500');

  return (
    <Fragment>
      <style>
        {`
          .branded-bg {
            position: relative;
            overflow: hidden;

            background-image: url('${toAbsoluteUrl('/media/images/metall.jpg')}');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            animation: branded-bg-move 30s ease-in-out infinite alternate;
          }

          /* white overlay for 50% opacity effect */
          .branded-bg::before {
            content: '';
            position: absolute;
            inset: 0;
            background-color: rgba(255, 255, 255, 0.5);
            pointer-events: none;
            z-index: 0;
          }

          /* keep content above overlay */
          .branded-bg > * {
            position: relative;
            z-index: 1;
          }

          /* dark mode: slightly stronger white overlay */
          .dark .branded-bg::before {
            background-color: rgba(255, 255, 255, 0.6);
          }

          /* single path – browser handles reversing smoothly */
          @keyframes branded-bg-move {
            from {
              background-position: 70% 70%;
            }
            to {
              background-position: 30% 30%;
            }
          }
        `}
      </style>

      <div className="grid lg:grid-cols-2 grow">
        <div className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1">
          <Outlet />
        </div>

        <div
          className="
            branded-bg
            order-1 lg:order-2
            lg:m-5
            lg:rounded-xl
            lg:border
            lg:border-gray-200
            place-content-center
          "
        >
          <div className="flex justify-center p-8 lg:p-16 gap-4">
            <div className="flex flex-col items-center gap-3">
              <img src={toAbsoluteUrl('/media/images/logo.svgz')} alt="Hettwer Metallbau" />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const AuthBrandedLayout = () => (
  <AuthBrandedLayoutProvider>
    <Layout />
  </AuthBrandedLayoutProvider>
);

export { AuthBrandedLayout };

export const BrandedVisual = () => (
  <Fragment>
    <style>
      {`
        .branded-bg {
          position: relative;
          overflow: hidden;

          background-image: url('${toAbsoluteUrl('/media/images/metall.jpg')}');
          background-size: 1000% 1000%;
          background-position: 50% 50%;
          background-repeat: no-repeat;

          animation: branded-bg-move 30s ease-in-out infinite alternate;
        }

        .branded-bg::before {
          content: '';
          position: absolute;
          inset: 0;
          background-color: rgba(255, 255, 255, 0.5);
          pointer-events: none;
          z-index: 0;
        }

        .branded-bg > * {
          position: relative;
          z-index: 1;
        }

        .dark .branded-bg::before {
          background-color: rgba(255, 255, 255, 0.6);
        }

        @keyframes branded-bg-move {
          from {
            background-position: 60% 60%;
          }
          to {
            background-position: 40% 40%;
          }
        }
      `}
    </style>

    <div
      className="
        branded-bg
        lg:m-5
        lg:rounded-xl
        lg:border
        lg:border-gray-200
        place-content-center
      "
    >
      <div className="flex justify-center p-8 lg:p-16 gap-4">
        <div className="flex flex-col items-center gap-3">
          <img src={toAbsoluteUrl('/media/images/logo.svgz')} alt="Hettwer Metallbau" />
        </div>
      </div>
    </div>
  </Fragment>
);

